<template>

  <div class="col-xxl-12" v-show="!loading">
      <div class="row">
        <div class="col-xxl-4">
          <div :class="widgetClasses" class="card">
            <div class="card-body py-3">
              <h3 class="card-title align-items-start flex-column mb-5">
                <span class="card-label fw-bolder fs-3 mb-1">Search Filter</span>
              </h3>
              <div class="row">
									<div class="col-md-12">
										<br>
											<div class="form-group col-md-12">
												<div class="mb-2">
													<select v-model="searchField" class="mb-md form-control">
														<option value="fullname">Fullname</option>
                            <option value="username">Username</option>
                            <option value="usid">User ID</option>
                            </select>
												</div>
												<div class="mb-2">
													<input v-show="searchField != 'fullname'" type="text" name="searchKey" class="form-control" v-model="searchKey" placeholder="Search here..">
													<input v-show="searchField == 'fullname'" type="text" class="form-control fullname-class" v-model="fullnameFirst" placeholder="First Name"/>
													&nbsp;
													<input v-show="searchField == 'fullname'" type="text" class="form-control fullname-class" v-model="fullnameMiddle" placeholder="Middle Name"/>
													&nbsp;
													<input v-show="searchField == 'fullname'" type="text" class="form-control fullname-class" v-model="fullnameLast" placeholder="Last Name"/>
												</div>
                        <div class="col-md-2">
                            <button type="button" id="manageUserSearch" class="btn btn-success" v-on:click="searchUser();"><strong>Search</strong></button>
                        </div>
												<!-- /.col -->
											</div>
										</div>
									</div>
            </div>
          </div>
        </div>
        <div class="col-xxl-8">
          <div :class="widgetClasses" class="card">
            <div class="card-body py-3">
              <h3 class="card-title align-items-start flex-column mb-5">
                <span class="card-label fw-bolder fs-3 mb-1">Search Result</span>
              </h3>
              <div class="table-responsive">
                <!--begin::Table-->
                <table class="table align-middle gs-0 gy-4">
                  <!--begin::Table head-->
                  <thead>
                    <tr class="fw-bolder text-muted bg-light">
                      <th class="ps-4 min-w-50px rounded-start">#</th>
                      <th class="min-w-50px">First Name</th>
                      <th class="min-w-50px">Middle Name</th>
                      <th class="min-w-100px">Last Name</th>
                      <th class="min-w-90px">Username</th>
                      <th class="min-w-125px">Action</th>
                    </tr>
                  </thead>
                  <!--end::Table head-->
                  <!--begin::Table body-->
                  <tbody>
                    <template v-for="(item, index) in list" :key="index">
                      <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;{{item.id}}</td>
                        <td>{{item.firstName}}</td>
                        <td>{{item.middleName}}</td>
                        <td>{{item.lastName}}</td>
                        <td>{{item.username}}</td>
                        <td>
                          <a href="javascript:void(0);" class="btn btn-info" v-on:click="overrideNow(item.cifId);">
                            Override
                          </a>
                        </td>
                      </tr>
                    </template> 
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {searchUserForOverride, overridenow}  from "@/api/override";
import {resetLocalCache} from "@/api/common";
import { string } from "yup/lib/locale";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentUser, getCurrentUser } from '@/utils/index';
import { UserRole } from '@/utils/auth.roles';


export default defineComponent({
  name: "reorder",
  components: {
  },
  data() {
    return { 
      list : [],
      searchField : "fullname",
      searchKey : "",
      fullnameFirst : "",
      fullnameMiddle : "",
      fullnameLast : "",
      currentUserID : "",
    }
  },
  mounted(){
      
  },
  methods : {
    async searchUser(){
       var param = {
        "page" : 1,
        "searchField" : this.searchField,
        "searchKey" : this.searchKey,
        "fullnameF" : this.fullnameFirst,
        "fullnameM" : this.fullnameMiddle,
        "fullnameL" : this.fullnameLast
      };
      const response = await searchUserForOverride(param);
      this.list = response.data.pageList;
      console.log(response.data);
    },
    async overrideNow(cifid){
      var param = {
        "cifid" : cifid
      };
      const response = await overridenow(param);
        

        const user = {
            un: response.data.email,
            fname: response.data.fname,
            mname: response.data.mname,
            lname: response.data.lname,
            avatar: response.data.avatar,
            role: UserRole.User,
            usid: response.data.usid,
            email: response.data.email,
            address: response.data.address,
            bday: response.data.bday,
            mobile: response.data.mobile
        };
        setCurrentUser(user);

        localStorage.ec_current_usid = response.data.usid;
        this.currentUserID = localStorage.ec_current_usid;

        if (response.data.result == "SUCCESS") {
            localStorage.setItem('override_cifid', cifid);
            localStorage.removeItem("vgetaccountlist_local_data");
            localStorage.removeItem("vgetaccountlist_local_data_timestamp");
            resetLocalCache();


            if(localStorage.getItem("pt") === 'ovi'){
               //this.$router.push('/dashboard/reminderspage');
               //window.location.assign('/dashboard/reminderspage');
               window.location.reload;
            } else {
              if(localStorage.getItem("pt") === 'ecp' || localStorage.getItem("pt") === 'edp'){
                //this.$router.push('/dashboardecp/reminderspage');
                //window.location.assign('/dashboardecp/reminderspage');
                window.location.reload;
              }
            }
            window.location.reload();
            
        } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
          }

      
    }
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("overrideTab") || "0");
      setCurrentPageTitle("Override Account");

    });
    
  }
});
</script>
